// extracted by mini-css-extract-plugin
export default {"Container":"Avatar_Container__qgXvT","Loading":"Avatar_Loading__P8n9b"};